var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-add-user",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-add-user:not(.animated) .animable {opacity: 0;}svg#freepik_stories-add-user.animated #freepik--Device--inject-96 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-add-user.animated #freepik--User--inject-96 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-96",
    className: "animable",
    style: {
      transformOrigin: "250.17px 340.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-96",
    cx: 250.17,
    cy: 340.24,
    rx: 230.3,
    ry: 132.96,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250.17px 340.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-96",
    className: "animable",
    style: {
      transformOrigin: "115.96px 81.6236px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-96",
    className: "animable",
    style: {
      transformOrigin: "115.96px 81.6236px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.13,58.64l-8.28,4.77a8.08,8.08,0,0,0,.07-1.09v-2.4c0-4.27-3-6-6.68-3.86a12.82,12.82,0,0,0-4,3.83c-.6-5.36-4.81-7.36-9.92-4.41-5.53,3.19-10,11-10,17.33V76.4a9.45,9.45,0,0,0,.85,4.15l-6.87,4a8.19,8.19,0,0,0-3.71,6.42c0,2.37,1.66,3.33,3.71,2.15L121.13,67.2a8.19,8.19,0,0,0,3.71-6.42C124.84,58.41,123.18,57.45,121.13,58.64Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "98.715px 73.8703px"
    },
    id: "elt0mhsa4u2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53,82.74l-6.24,3.6a7.52,7.52,0,0,0,.05-.82V83.71c0-3.22-2.26-4.52-5.05-2.91a9.67,9.67,0,0,0-3,2.89c-.46-4-3.64-5.56-7.49-3.33a16.7,16.7,0,0,0-7.56,13.08v2.71a7.26,7.26,0,0,0,.64,3.13l-5.18,3a6.2,6.2,0,0,0-2.8,4.85c0,1.79,1.25,2.51,2.8,1.62l33.83-19.53a6.2,6.2,0,0,0,2.8-4.85C159.33,82.57,158.08,81.85,156.53,82.74Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "139.615px 94.2349px"
    },
    id: "ele66m9iz9aaa",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-96",
    className: "animable",
    style: {
      transformOrigin: "88.8684px 341.992px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-96",
    className: "animable",
    style: {
      transformOrigin: "88.8684px 341.992px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.78,386.08l10.33-6s2.53-22.11.84-39.23c-2.36-24.06-17.9-53-36.44-46.21S87,326,93,346.39,103.78,386.08,103.78,386.08Z",
    style: {
      fill: "current",
      transformOrigin: "93.8201px 339.857px"
    },
    id: "ellc57v7q08o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljfhrd3tutsj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.78,386.08l10.33-6s2.53-22.11.84-39.23c-2.36-24.06-17.9-53-36.44-46.21S87,326,93,346.39,103.78,386.08,103.78,386.08Z",
    style: {
      opacity: 0.2,
      transformOrigin: "93.8201px 339.857px"
    },
    className: "animable",
    id: "elgquenxw6du8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,383.57h0a.62.62,0,0,1-.6-.64c1.81-53.47-24.8-80.36-25.07-80.62a.63.63,0,1,1,.88-.89c.27.26,27.27,27.55,25.44,81.55A.62.62,0,0,1,109.21,383.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "96.6237px 342.377px"
    },
    id: "eluw9ysuowxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27,390.35l7.35-4.24s1.25-15.17-6.19-33.61c-6.48-16-22.54-29.35-30.62-26.56s-7.89,8.53-4,14.54S92.78,360.82,98.27,390.35Z",
    style: {
      fill: "current",
      transformOrigin: "83.9521px 357.96px"
    },
    id: "elifgxdljf378",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.15,388.74h0a.63.63,0,0,1-.63-.63c.15-33.8-31.59-56.65-31.91-56.88a.62.62,0,0,1,.72-1c.32.23,32.59,23.46,32.44,57.91A.62.62,0,0,1,102.15,388.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "86.0884px 359.445px"
    },
    id: "elnamg1clud9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-96",
    className: "animable",
    style: {
      transformOrigin: "231.09px 218.081px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-96",
    className: "animable",
    style: {
      transformOrigin: "231.09px 218.081px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.6,343.36l-64,37-.15-.08L208.1,366.21a13.13,13.13,0,0,1-5.9-12.92l9-46.92,64-37-9,46.92a13.13,13.13,0,0,0,5.9,12.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "249.333px 324.865px"
    },
    id: "ely68kua6ljz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.23 306.37 202.27 352.88 266.29 315.93 274.57 272.91 270.53 272.1 211.23 306.37",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.42px 312.49px"
    },
    id: "elnra7la0y3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58,380.35l-24.49-14.14a13.15,13.15,0,0,1-5.9-12.92l9-46.92-10.67-6.17-10.32,53.68c-1.37,7.1,2.64,15.87,8.9,19.48l33.45,19.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.256px 346.435px"
    },
    id: "elfl30e5uzdu9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.6 343.36 232.58 380.35 232.58 392.68 296.6 355.69 296.6 343.36",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "264.59px 368.02px"
    },
    id: "elrxfcv036j8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.23,39.31c2.94,1.7,5.33,6,5.33,9.65V245.42a12.57,12.57,0,0,1-5.69,9.85L114,396.66c-3.14,1.81-8.08,1.9-11,.2s-5.34-6-5.34-9.65V190.75a12.6,12.6,0,0,1,5.69-9.86L348.2,39.51C351.34,37.69,356.28,37.6,359.23,39.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "231.11px 218.081px"
    },
    id: "elkg0eoykczuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.32,397c-3.14,1.47-7.61,1.44-10.36-.14-2.95-1.7-5.34-6-5.34-9.65V190.75a11.67,11.67,0,0,1,1.67-5.61L110,191.31a11.61,11.61,0,0,0-1.67,5.6V393.37C108.3,396.74,110.49,398.25,113.32,397Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.47px 291.607px"
    },
    id: "elfe6jwqiyfhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.56,245.42V49c0-3.63-2.54-5.1-5.69-3.29L114,187.06a12.57,12.57,0,0,0-5.69,9.85V393.37c0,3.63,2.55,5.1,5.69,3.29L358.87,255.27A12.57,12.57,0,0,0,364.56,245.42Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "236.435px 221.185px"
    },
    id: "elwvbyiz960b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.06,55.7,118.19,190.8a10.06,10.06,0,0,0-4.55,7.88V373.11c0,2.9,2,4.08,4.55,2.63l233.88-135.1a10.06,10.06,0,0,0,4.55-7.88V58.33C356.62,55.43,354.58,54.25,352.06,55.7Z",
    style: {
      fill: "current",
      transformOrigin: "235.13px 215.72px"
    },
    id: "eldikalp8kibf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elihrc60u6qb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.06,55.7,118.19,190.8a10.06,10.06,0,0,0-4.55,7.88V373.11c0,2.9,2,4.08,4.55,2.63l233.88-135.1a10.06,10.06,0,0,0,4.55-7.88V58.33C356.62,55.43,354.58,54.25,352.06,55.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "235.13px 215.72px"
    },
    className: "animable",
    id: "elca64s0zc0c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-96",
    className: "animable",
    style: {
      transformOrigin: "235.13px 215.724px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.31,354.29c-1.24,0-2-1-2-2.71V213.44L341.93,90.12V227.68A9.39,9.39,0,0,1,337.7,235L132.06,353.74A3.58,3.58,0,0,1,130.31,354.29Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "235.12px 222.205px"
    },
    id: "el6hqem5tm03n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.43,91v136.7a8.91,8.91,0,0,1-4,6.9L131.81,353.31a3.15,3.15,0,0,1-1.5.48c-1.34,0-1.48-1.54-1.48-2.21V213.73L341.43,91m1-1.73-214.6,123.9V351.58c0,2,1,3.21,2.48,3.21a4,4,0,0,0,2-.62L337.94,235.45a9.91,9.91,0,0,0,4.49-7.77V89.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "235.13px 222.02px"
    },
    id: "eltbeaegwfw3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.83 213.15 127.83 232.58 342.43 108.68 342.43 89.25 127.83 213.15",
    style: {
      fill: "current",
      transformOrigin: "235.13px 160.915px"
    },
    id: "el7p8pepzte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.48,143v4.18c0,.85.61,1.2,1.35.78l66-38.1V102.6l-66,38.1A3,3,0,0,0,262.48,143Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "296.155px 125.369px"
    },
    id: "el1n1iadsktba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.88,98.52c.74-.43,1.34-.08,1.34.78v4.18a3,3,0,0,1-1.34,2.33l-7.07,4.08V102.6Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "334.015px 104.113px"
    },
    id: "el5a20tvn9qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,104.25l-.78-.24a4.44,4.44,0,0,0,.12-1,1.85,1.85,0,0,0-.72-1.68,1.11,1.11,0,0,0-1.15,0,4,4,0,0,0-1.57,3.28,1.87,1.87,0,0,0,.72,1.69,1,1,0,0,0,.5.13,1.27,1.27,0,0,0,.65-.19,3.31,3.31,0,0,0,1.27-1.7l.79.24.09,0a.3.3,0,0,0,.28-.21A.31.31,0,0,0,336.35,104.25Zm-2.53,1.52a.55.55,0,0,1-.56,0,1.37,1.37,0,0,1-.43-1.18,3.5,3.5,0,0,1,1.29-2.77.71.71,0,0,1,.35-.11.46.46,0,0,1,.21,0,1.4,1.4,0,0,1,.43,1.18A3.54,3.54,0,0,1,333.82,105.77Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "334.395px 103.8px"
    },
    id: "el99hcjpi5bnu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83,203.76a9.9,9.9,0,0,1,4.48-7.77L337.94,77.27c2.48-1.43,4.49-.27,4.49,2.59v9.39l-214.6,123.9Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "235.13px 144.904px"
    },
    id: "el9t33xxz0eho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,94.1a4.65,4.65,0,0,0-2.1,3.64c0,1.35.94,1.89,2.1,1.22a4.63,4.63,0,0,0,2.11-3.65C319.29,94,318.35,93.43,317.18,94.1Z",
    style: {
      fill: "current",
      transformOrigin: "317.185px 96.5325px"
    },
    id: "eltgz8fh4fcie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,89.86a4.63,4.63,0,0,0-2.11,3.64c0,1.34.94,1.89,2.11,1.22a4.65,4.65,0,0,0,2.1-3.65C326.65,89.73,325.71,89.19,324.55,89.86Z",
    style: {
      fill: "current",
      transformOrigin: "324.545px 92.289px"
    },
    id: "elmdbukxbupw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.91,85.62a4.65,4.65,0,0,0-2.1,3.64c0,1.34.94,1.89,2.1,1.22a4.66,4.66,0,0,0,2.1-3.65C334,85.49,333.07,85,331.91,85.62Z",
    style: {
      fill: "current",
      transformOrigin: "331.91px 88.0599px"
    },
    id: "elwc52zpvtljf",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.91,217.72l26.44-15.26c1.67-1,3-.19,3,1.75v30.52a6.72,6.72,0,0,1-3,5.25l-26.44,15.26c-1.67,1-3,.18-3-1.75V223A6.69,6.69,0,0,1,221.91,217.72Z",
    style: {
      fill: "current",
      transformOrigin: "235.13px 228.849px"
    },
    id: "elrckzxr39jhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.17,255.74l16-9.22c1.2-.7,2.16-.2,2.16,1.09a4.67,4.67,0,0,1-2.16,3.6l-16,9.22c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,229.17,255.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "237.165px 253.473px"
    },
    id: "el6go5ict5xe8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9,216.6c2.81-1.62,5.08-.31,5.08,2.93a11.2,11.2,0,0,1-5.08,8.79c-2.8,1.62-5.07.31-5.07-2.93A11.22,11.22,0,0,1,234.9,216.6Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "234.905px 222.46px"
    },
    id: "eld98dtcxcrwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.91,233.91c0-5.31-3.74-7.68-8.34-5l-2.88,1.67c-4.61,2.66-8.34,9.12-8.34,14.44v1.43l19.56-11.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "235.13px 237.125px"
    },
    id: "elpxn73kbstk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,189.54l26.43-15.26c1.68-1,3-.19,3,1.75v30.52a6.7,6.7,0,0,1-3,5.25l-26.43,15.26c-1.67,1-3,.18-3-1.75V194.79A6.7,6.7,0,0,1,270.68,189.54Z",
    style: {
      fill: "current",
      transformOrigin: "283.895px 200.669px"
    },
    id: "elvsbhvxz0vm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb7fgbk3fi0h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.68,189.54l26.43-15.26c1.68-1,3-.19,3,1.75v30.52a6.7,6.7,0,0,1-3,5.25l-26.43,15.26c-1.67,1-3,.18-3-1.75V194.79A6.7,6.7,0,0,1,270.68,189.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "283.895px 200.669px"
    },
    className: "animable",
    id: "elopqoven438f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.94,227.56l16-9.22c1.19-.69,2.16-.2,2.16,1.09a4.65,4.65,0,0,1-2.16,3.6l-16,9.22c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,277.94,227.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.935px 225.295px"
    },
    id: "el9bhj6f7aq5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.67,188.42c2.81-1.62,5.08-.31,5.08,2.93a11.19,11.19,0,0,1-5.08,8.79c-2.8,1.62-5.07.31-5.07-2.93A11.23,11.23,0,0,1,283.67,188.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "283.675px 194.28px"
    },
    id: "elhgmrdmkudwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.68,205.73c0-5.31-3.74-7.68-8.34-5l-2.88,1.67c-4.61,2.66-8.34,9.12-8.34,14.44v1.43L293.68,207Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "283.9px 208.945px"
    },
    id: "elfwibiix4n1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,245.83l26.44-15.26c1.67-1,3-.18,3,1.75v30.52a6.69,6.69,0,0,1-3,5.25l-26.44,15.26c-1.67,1-3,.19-3-1.75V251.08A6.72,6.72,0,0,1,173.19,245.83Z",
    style: {
      fill: "current",
      transformOrigin: "186.41px 256.961px"
    },
    id: "eldnbo9ma94wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrd3ligwcoh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.19,245.83l26.44-15.26c1.67-1,3-.18,3,1.75v30.52a6.69,6.69,0,0,1-3,5.25l-26.44,15.26c-1.67,1-3,.19-3-1.75V251.08A6.72,6.72,0,0,1,173.19,245.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "186.41px 256.961px"
    },
    className: "animable",
    id: "el8rjmsosmepm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,283.85l16-9.22c1.2-.69,2.16-.2,2.16,1.09a4.65,4.65,0,0,1-2.16,3.6l-16,9.22c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,180.45,283.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "188.445px 281.585px"
    },
    id: "elzalry60ksjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.18,244.71c2.81-1.62,5.08-.3,5.08,2.93a11.22,11.22,0,0,1-5.08,8.8c-2.8,1.61-5.07.3-5.07-2.94A11.23,11.23,0,0,1,186.18,244.71Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "186.185px 250.573px"
    },
    id: "elj67rugakil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,262c0-5.32-3.74-7.68-8.34-5L185,258.67c-4.61,2.66-8.34,9.13-8.34,14.45v1.43l19.56-11.29Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "186.44px 265.219px"
    },
    id: "ellbs09fag4qj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--User--inject-96",
    className: "animable",
    style: {
      transformOrigin: "380.285px 271.126px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.68,182.63l-10.62-6.13c-10.71-6-25.39-5.15-41.66,4.24-15.22,8.77-29.1,23.41-39.56,40.35-12.1,19.5-19.71,42.08-19.71,62.32,0,18.88,6.61,32.12,17.3,38.33l10.73,6.15c10.8,6.88,26,6.27,43-3.49,32.74-18.91,59.28-64.88,59.28-102.68C445.4,202,438.2,188.47,426.68,182.63Z",
    style: {
      fill: "current",
      transformOrigin: "380.285px 252.585px"
    },
    id: "elianq3qqisr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elizoxor5m71d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.74,327.64l-10.31-5.9c-10.69-6.2-17.29-19.46-17.29-38.34,0-20.24,7.61-42.8,19.7-62.3l11.68,6.79c-12.1,19.5-19.69,42.05-19.69,62.27C326.83,308.21,332.87,321.11,342.74,327.64Z",
    style: {
      opacity: 0.1,
      transformOrigin: "330.83px 274.37px"
    },
    className: "animable",
    id: "elkr98hk3brg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el23eufwi7awb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.25,182.38c-10.56-5.12-24.65-3.82-40.12,5.1-15.24,8.81-29.12,23.46-39.61,40.41l-11.68-6.79c10.47-17,24.36-31.58,39.57-40.35,16.26-9.4,30.95-10.29,41.67-4.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "380.545px 200.282px"
    },
    className: "animable",
    id: "el40y5m47o39y"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.53,324.48a22.32,22.32,0,0,1-12.22-3.34l-.17-.11-.34-.19c-7.81-5.32-12.11-16.2-12.11-30.69,0-18,6.73-39.11,18.48-58,10.2-16.48,23.27-29.87,36.82-37.7,7.95-4.59,15.73-7,22.47-7a23,23,0,0,1,9.93,2.09l.36.2.18.09c9.11,4.61,14.33,16.25,14.33,31.94,0,35.21-24.8,78.16-55.29,95.75C374,322.06,366.27,324.48,359.53,324.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "385.975px 255.966px"
    },
    id: "el7dkwye720tm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "392.447px 287.492px"
    },
    id: "elw34e8yfrk4",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.72,267.49h0c-15.09,4-27.33-4.92-27.33-20v-9.67c0-12.79,10.37-25.93,23.16-29.36l8.33-2.23c12.79-3.43,23.16,4.16,23.16,16.95v9.67C416,247.93,403.81,263.44,388.72,267.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.715px 236.926px"
    },
    id: "elroy2oiu8hw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,361c.1-1.6,2.65-19.1,4.41-29l17.12,1.47-6.24,36.09-11.23-.73C346.58,369,346.93,362.58,347,361Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "357.747px 350.78px"
    },
    id: "el5aevxqfdtip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.87 305.61 437.93 343.36 422.85 351.62 413.81 316.11 425.87 305.61",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "425.87px 328.615px"
    },
    id: "elh21coavtxs4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.47,273.28c8-2,16.87-1,19.91,5.4s9.69,29.39,9.69,29.39a28.07,28.07,0,0,1-17,10.79Z",
    style: {
      fill: "current",
      transformOrigin: "414.27px 295.607px"
    },
    id: "elaooix18r0xt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvoxnavjvt2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.47,273.28c8-2,16.87-1,19.91,5.4s9.69,29.39,9.69,29.39a28.07,28.07,0,0,1-17,10.79Z",
    style: {
      opacity: 0.3,
      transformOrigin: "414.27px 295.607px"
    },
    className: "animable",
    id: "elatb90sqn5gh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.85,278.06l-6.68,2.11c-7.27,4-9.89,10.42-12.94,18.69a28.23,28.23,0,0,0-.58,18.32l8.51,26.15s-4,12.18-8.61,23.93c21.35,8,48-6.34,54.43-18.1.28-2.21-.09-11.71.42-22.77.56-11.8,1.94-25.32.36-32.1-2.95-12.57-8.46-23.64-19.44-20.7Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "389.946px 321.345px"
    },
    id: "el7k0g4rvaqa2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.17,280.17c-7.28,3.14-18,7.7-21.67,28.69-3.74,21.27-4.46,26.29-4.46,26.29s6.37,5.63,18.46,2.32C368.5,337.47,379.16,294.82,376.17,280.17Z",
    style: {
      fill: "current",
      transformOrigin: "363.37px 309.341px"
    },
    id: "elxoclru29h8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8s9b9gukdpq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.17,280.17c-7.28,3.14-18,7.7-21.67,28.69-3.74,21.27-4.46,26.29-4.46,26.29s6.37,5.63,18.46,2.32C368.5,337.47,379.16,294.82,376.17,280.17Z",
    style: {
      opacity: 0.3,
      transformOrigin: "363.37px 309.341px"
    },
    className: "animable",
    id: "elbzflfxg0no"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,308.48h0c8.55-2.29,15.49-11.08,15.49-19.63v-27.5h0c-8.56,2.3-15.49,11.09-15.49,19.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.565px 284.915px"
    },
    id: "ele5wlhgwytsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.82,336.15c1.35-5.67,2.77-12.12,4.11-19,0,0-.06,14.22-2.16,25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.875px 329.65px"
    },
    id: "elihf2txvta68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07,215.18c2.88,1.19,6.45,8.62,6.1,26.29-.3,15-4.48,19.77-6.58,21.39s-6.15,2.06-10.08,2.36v8.94s5.44,5.84,5.09,10-7.85,7.17-12.94,4.53a24.72,24.72,0,0,1-8.35-7.86V259.25s-2.66,4.81-7,2.64-4.51-10.37-2-14,8-4.16,9-.34c0,0,6.27-1.41,14.63-9A37.91,37.91,0,0,0,407.07,215.18Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "391.435px 252.431px"
    },
    id: "elpiyscd4cev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,241.58a2.54,2.54,0,0,1-1.54,2.45c-.89.28-1.66-.34-1.7-1.4a2.53,2.53,0,0,1,1.53-2.45C398,239.9,398.72,240.52,398.77,241.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.15px 242.105px"
    },
    id: "elwmr4ceijkid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.2,254.09l3.77.38a2.63,2.63,0,0,1-2.45,2.22C399.48,256.58,398.89,255.42,399.2,254.09Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "401.044px 255.39px"
    },
    id: "elprbtoomizf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,232.27l-3.29-1.75c.6-1.24,1.82-1.86,2.73-1.37S412.66,231,412.07,232.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.586px 230.626px"
    },
    id: "el8z5sul1qjqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.31,236.87a2.51,2.51,0,0,1-1.54,2.44c-.89.29-1.65-.34-1.7-1.4a2.52,2.52,0,0,1,1.53-2.44C410.5,235.18,411.26,235.81,411.31,236.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "409.69px 237.39px"
    },
    id: "el0hm092icy8gb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.66 237.85 403.92 249.05 409.05 245.84 403.66 237.85",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "406.355px 243.45px"
    },
    id: "eleqi2bcu2c1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.51,265.22c-4.15.48-12.68-.06-14-3.6a7.38,7.38,0,0,0,3,4.17c2.55,1.84,11,2.41,11,2.41Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "389.51px 264.91px"
    },
    id: "eligpoeucdke",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.56,306.12l-8.17-4.72h0l-.09,0v0c-4.06-2.3-9.63-2-15.8,1.6-5.77,3.33-11,8.88-15,15.3-4.58,7.4-7.47,16-7.47,23.64,0,7.15,2.51,12.18,6.56,14.53h0l8.3,4.74c4.09,2.61,9.87,2.38,16.29-1.33,12.41-7.17,22.48-24.6,22.48-38.93C378.66,313.47,375.93,308.33,371.56,306.12Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "351.845px 331.441px"
    },
    id: "elu12sout323",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,361.1l-8.13-4.64h0c-4.06-2.35-6.56-7.38-6.56-14.54,0-7.67,2.88-16.23,7.47-23.62l8.68,5c-4.59,7.4-7.47,15.94-7.47,23.61C333.69,353.73,336,358.63,339.72,361.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.105px 339.7px"
    },
    id: "elpd770zavjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.39,306c-4-1.94-9.34-1.45-15.21,1.94s-11,8.89-15,15.32l-8.68-5c4-6.43,9.24-12,15-15.3,6.17-3.56,11.74-3.9,15.8-1.61v0l.09,0h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "351.945px 311.58px"
    },
    id: "elqwhemtel3fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,325.27l-7.49,4.33v-12c0-1.93-1-2.9-2.26-2.18s-2.26,2.86-2.26,4.79v12l-7.5,4.33a5.16,5.16,0,0,0-1.95,4.13c0,1.66.88,2.5,1.95,1.87l7.5-4.32v12c0,1.93,1,2.9,2.26,2.18s2.26-2.87,2.26-4.79v-12l7.49-4.33a5.13,5.13,0,0,0,1.95-4.13C367.88,325.49,367,324.65,365.93,325.27Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "356.175px 333.91px"
    },
    id: "elxrhux64jfx",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.53,324.48a22.32,22.32,0,0,1-12.22-3.34l-.17-.11-.34-.19c-7.81-5.32-12.11-16.2-12.11-30.69,0-18,6.73-39.11,18.48-58,10.2-16.48,23.27-29.87,36.82-37.7,7.95-4.59,15.73-7,22.47-7a23,23,0,0,1,9.93,2.09l.36.2.18.09c9.11,4.61,14.33,16.25,14.33,31.94,0,35.21-24.8,78.16-55.29,95.75C374,322.06,366.27,324.48,359.53,324.48Z",
    style: {
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/userManagement.ef85b14a.svg";
export { ForwardRef as ReactComponent };